// extracted by mini-css-extract-plugin
export default {"container":"GMDashBoard_container__GALGi"};